import { put, call, select } from 'redux-saga/effects';
import type { SagaIterator } from 'redux-saga';
import { withOffset } from '../../Stream';
import { fetchDeviation } from '../../redux/deviations/actionCreators';
import { MEDIA_POPUP_BROWSE_SEARCH_DEVIATION_STREAM_ID } from '../constants';
import { initSingleDeviationByLookupStream } from '../actions';
import { fetchDeviationSaga } from '../../redux/deviations/saga';
import { getNormalizedDeviationById } from '../../redux/deviations/selectors';

type InitSingleDeviationByLookupStreamReturnType = ReturnType<
  typeof initSingleDeviationByLookupStream
>;

function* handleInitSingleDeviationByLookupStream({
  payload: { deviationid, type, username },
}: InitSingleDeviationByLookupStreamReturnType): SagaIterator {
  yield put(
    withOffset.actions.initialize({
      streamId: MEDIA_POPUP_BROWSE_SEARCH_DEVIATION_STREAM_ID,
      itemsPerFetch: 1,
      hasMore: false,
    })
  );
  // bit of a kludge but needed so we don't keep fetching from the
  // useEffect in the SearchInput
  yield put(withOffset.actions.markAsFetching(MEDIA_POPUP_BROWSE_SEARCH_DEVIATION_STREAM_ID));

  yield call(fetchDeviationSaga, fetchDeviation({ deviationid, type, username }));
  // fetch will normalize it and then we have to look it up in the normalized store
  // since we need the deviation and only have the id so far
  const deviation = yield select(getNormalizedDeviationById, deviationid);

  yield put(
    withOffset.actions.fetchAllSuccess({
      streamId: MEDIA_POPUP_BROWSE_SEARCH_DEVIATION_STREAM_ID,
      items: deviation ? [deviationid] : [],
    })
  );
}

export default handleInitSingleDeviationByLookupStream;
